"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreemptiveScheduler = void 0;
/* tslint:disable:max-classes-per-file */
const errors_1 = require("./errors/errors");
class PreemptiveScheduler {
    constructor(steps) {
        this.steps = steps;
    }
    run(it, context) {
        return new Promise(resolve => {
            context.runtime.isRunning = true;
            // This is used in the evaluation of the REPL during a paused state.
            // The debugger is turned off while the code evaluates just above the debugger statement.
            let itValue = it.next();
            const executionLoop = () => {
                setTimeout(() => {
                    let step = 0;
                    try {
                        while (!itValue.done && step < this.steps) {
                            step++;
                            itValue = it.next();
                        }
                    }
                    catch (e) {
                        checkForStackOverflow(e, context);
                        context.runtime.isRunning = false;
                        resolve({ status: 'error' });
                    }
                    if (itValue.done) {
                        context.runtime.isRunning = false;
                        resolve({ status: 'finished', context, value: itValue.value });
                    }
                    else {
                        executionLoop();
                    }
                });
            };
            executionLoop();
        });
    }
}
exports.PreemptiveScheduler = PreemptiveScheduler;
const StackOverflowMessages = {
    firefox: 'InternalError: too much recursion',
    // webkit: chrome + safari
    webkit: 'RangeError: Maximum call stack size exceeded',
    edge: 'Error: Out of stack space'
};
function checkForStackOverflow(error, context) {
    for (const message of Object.values(StackOverflowMessages)) {
        if (error.toString().includes(message)) {
            const environments = context.runtime.environments;
            const stacks = [];
            let counter = 0;
            for (let i = 0; counter < errors_1.MaximumStackLimitExceeded.MAX_CALLS_TO_SHOW && i < environments.length; i++) {
                const procedureName = environments[i].procedureName;
                if (procedureName) {
                    stacks.unshift(procedureName);
                    counter++;
                }
            }
            context.errors.push(new errors_1.MaximumStackLimitExceeded(context.runtime.nodes[0], stacks));
        }
    }
}
//# sourceMappingURL=schedulers.js.map